import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const load = () => {
  try {
    return JSON.parse(localStorage.getItem("pm_cart") || "[]");
  } catch {
    return [];
  }
};

export function CartProvider({ children }) {
  const [items, setItems] = useState(load); // [{product, quantity}]

  useEffect(() => {
    localStorage.setItem("pm_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product.product_id === product.product_id);
      if (found)
        return prev.map((i) =>
          i.product.product_id === product.product_id ? { ...i, quantity: i.quantity + qty } : i
        );
      return [...prev, { product, quantity: qty }];
    });
  };

  const setQty = (productId, qty) => {
    if (qty <= 0) return removeItem(productId);
    setItems((prev) => prev.map((i) => (i.product.product_id === productId ? { ...i, quantity: qty } : i)));
  };

  const removeItem = (productId) =>
    setItems((prev) => prev.filter((i) => i.product.product_id !== productId));

  const clear = () => setItems([]);

  const getQty = (productId) => items.find((i) => i.product.product_id === productId)?.quantity || 0;

  const { count, subtotal } = useMemo(() => {
    let count = 0;
    let subtotal = 0;
    items.forEach((i) => {
      count += i.quantity;
      subtotal += i.quantity * i.product.price;
    });
    return { count, subtotal: Math.round(subtotal * 100) / 100 };
  }, [items]);

  const charge = subtotal <= 0 ? 0 : subtotal < 110 ? 15 : Math.round(subtotal * 0.15 * 100) / 100;
  const chargeLabel = subtotal < 110 ? "Service charge (flat)" : "Service charge (15%)";
  const grandTotal = Math.round((subtotal + charge) * 100) / 100;

  return (
    <CartContext.Provider
      value={{ items, addItem, setQty, removeItem, clear, getQty, count, subtotal, charge, chargeLabel, grandTotal }}
    >
      {children}
    </CartContext.Provider>
  );
}
